import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import KpiDashboard from '../../kpi/KpiDashboard';//eslint-disable-line import/no-named-as-default
import Conversation from '../../conversationDialog/ChildConversationDialog';
import Resources from '../../resourceLinks/ResourceLinks';
import * as trackingDataActions from '../../../../actions/trackingDataActions';
import * as userDataActions from '../../../../actions/userDataActions';
import * as appHelper from '../../../../helpers/appHelper';
import * as appConstants from '../../../../constants/appConstants';
import * as kpiConstants from '../../../../constants/kpiConstants';
import * as objectConstants from '../../../../constants/objectConstants';
import {TweenLite, Elastic, Bounce, Expo, Linear} from 'gsap';
import gsap from 'gsap-react-plugin';

class SingleAnswerFeedbackReview extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            option: this.props.option,
            locale: appHelper.getLocalData(this.props.option),
            showFeedbackContent: false,
            showKpis: appHelper.isDefined(this.props.option.kpis) && this.props.option.kpis !== null,
            kpiDashboardParams: {
                responseReview: true,
                showTitle: false,
                showImmediateImpact: true,
                allowUpdates: false
            },
            hasDialogs: appHelper.isDefined(this.props.option.dialogs) && this.props.option.dialogs.length > 0,
            dialogComplete: !appHelper.isDefined(this.props.option.dialogs) || this.props.option.dialogs.length === 0,
            callbacks: {},
            resourceLinks: [],
            hasResources: false,
            resourcesAreComplete: true,
        };

        this.show = this.show.bind(this);
        this.onFeedbackRevealed = this.onFeedbackRevealed.bind(this);
        this.showFeedbackContent = this.showFeedbackContent.bind(this);
        this.showKpiDashboard = this.showKpiDashboard.bind(this);
        this.dialogsOnComplete = this.dialogsOnComplete.bind(this);
        this.setCallbacks = this.setCallbacks.bind(this);
        this.onResourcesComplete = this.onResourcesComplete.bind(this);
        this.setResources = this.setResources.bind(this);
        this.getInheritedFeedback = this.getInheritedFeedback.bind(this);
    }

    componentDidMount() {
        this.setCallbacks();
        this.setResources();
        this.show();
    }

    componentWillReceiveProps(nextProps) {
        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.option)
            });
        }
    }

    show() {

        let feedbackPanel = this.refs[`${this.state.option.option_id}_feedbackPanel`];
        TweenLite.set(feedbackPanel, {height: "auto", opacity: 1});
        TweenLite.from(feedbackPanel, objectConstants.FEEDBACK_DURATION, {
            height: 0,
            opacity: 0,
            ease: Expo.easeInOut
        }).eventCallback("onComplete", this.onFeedbackRevealed);
    }

    onFeedbackRevealed() {
        // this.setState({showResponse: true});
        this.showFeedbackContent();
    }

    showFeedbackContent() {
        if (appHelper.isDefined(this.state.option.kpis) && this.state.option.kpis !== null) {
            this.setState({showFeedbackContent: true, showKpis: true});
        } else {
            this.setState({showFeedbackContent: true});
        }
    }

    showKpiDashboard() {

    }

    dialogsOnComplete() {
        this.setState({dialogComplete: true});
    }

    setCallbacks() {

    }

    setResources() {
        let resourceLinks = appHelper.setResourceLinks(this.state.option);
        let hasRequiredResources = appHelper.hasRequiredResources(resourceLinks);
        this.setState({
            resourceLinks: Object.assign([], resourceLinks),
            hasResources: resourceLinks.length > 0,
            resourcesAreComplete: resourceLinks.length === 0 || !hasRequiredResources
        });

    }

    onResourcesComplete() {
        if (!this.state.resourcesAreComplete) {
            this.setState({resourcesAreComplete: true, checkComplete: true});
        }
    }

    getInheritedFeedback(feedback_id) {
        let option = appHelper.getArrayObjectByKey(this.props.options, "option_id", feedback_id);
        let optionLocale = appHelper.getLocalData(option);
        return optionLocale.feedback;
    }

    render() {
        return (
            <div className="clear-both">
                {this.state.hasDialogs
                    ?
                    <Conversation asset_id={this.props.asset_id} option_id={this.state.option.option_id}
                                  dialogs={this.state.option.dialogs} callbacks={this.state.callbacks}
                                  onComplete={this.dialogsOnComplete}/>
                    :
                    null
                }
                {this.state.hasDialogs
                    ?
                    <br/>
                    :
                    null
                }
                <div className={`feedback-panel ${this.state.option.result} review object-container`}
                     ref={`${this.state.option.option_id}_feedbackPanel`}>
                    <img src={require(`../../../../assets/images/svg/${this.state.option.result}.svg`)} style={kpiConstants.WATERMARK_STYLES} alt=""/>

                    <div className="feedback-content-col">

                        {this.state.showKpis && this.state.dialogComplete
                            ? <KpiDashboard displayState={kpiConstants.KPI_DISPLAY_STATE_REVIEW_POINTS_AWARDED}
                                            bite_id={this.props.responseData.bite_id}
                                            screen_id={this.props.responseData.screen_id}
                                            asset_id={parseInt(this.props.responseData.asset_id)}
                                            option={this.props.option}
                                            responseReview={this.state.kpiDashboardParams.responseReview}
                                            showImmediateImpact={this.state.kpiDashboardParams.showImmediateImpact}
                                            showTitle={this.state.kpiDashboardParams.showTitle}/>
                            : null
                        }


                        {appHelper.isDefined(this.state.locale.feedback) && this.state.dialogComplete && this.state.locale.feedback.length > 0
                            ? <div dangerouslySetInnerHTML={{__html: this.state.locale.feedback}}/>
                            :
                            appHelper.isDefined(this.state.option.feedback_id)
                                ?
                                <div
                                    dangerouslySetInnerHTML={{__html: this.getInheritedFeedback(this.state.option.feedback_id)}}/>
                                :
                                null
                        }

                        {
                            this.state.hasResources
                                ?
                                <Resources resources={this.state.resourceLinks}
                                           onResourcesComplete={this.onResourcesComplete}/>
                                :
                                null
                        }

                    </div>
                </div>
            </div>
        );
    }
}

SingleAnswerFeedbackReview.propTypes = {
    option: PropTypes.object.isRequired,
    options: PropTypes.array.isRequired,
    responseData: PropTypes.object.isRequired,
    asset_id: PropTypes.number.isRequired,
    callbacks: PropTypes.object,
    onComplete: PropTypes.func,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object
};

SingleAnswerFeedbackReview.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, trackingDataActions, userDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SingleAnswerFeedbackReview);



/** WEBPACK FOOTER **
 ** ./src/components/objects/multipleChoice/singleAnswer/SingleAnswerFeedbackReview.js
 **/